'use client'
import React from 'react'

const contentData = [
   {
      type: 'text',
      content:
         'Welcome to the official website of Benzatine Infotech ("Benzatine," "we," "our," or "us"). These Terms and Conditions ("Terms") govern your use of our website and digital properties located at https://benzatine.com ("Site"). By accessing or using our Site, you agree to be bound by these Terms in full. If you do not agree with any part of these Terms, you must not use our Site or any services offered through it.',
   },
   {
      type: 'text',
      content:
         'Benzatine Infotech is a technology and digital services firm that provides innovative software development, product engineering, and IT solutions. These Terms apply to all visitors, users, clients, partners, vendors, and stakeholders interacting with or accessing any information or services provided via our Site. We may also enter into project-specific agreements and non-disclosure contracts, which shall supersede these Terms in case of any conflict.',
   },
   {
      type: 'text',
      content:
         'Legal Status of the Company Benzatine Infotech is a registered business entity operating under the jurisdiction of Indian commercial law. While we are not a Private Limited Company, we conduct all operations in accordance with the statutory, legal, and ethical regulations applicable to IT services companies. We maintain full transparency in our engagements, transactions, and partnerships and are committed to professional standards of service.',
   },
   {
      type: 'list',
      content: 'Services Offered Our services include but are not limited to:',
      items: [
         'Custom software development',
         'Mobile and web application development',
         'SaaS platform engineering',
         'Business automation solutions',
         'UI/UX design',
         'IT consulting and project planning',
         'API and system integrations',
         'Cloud-based application deployment',
      ],
   },
   {
      type: 'text',
      content:
         'These services are rendered upon client request, followed by detailed discussions, requirement analysis, formal quotations, and mutual agreement via a Statement of Work (SOW), project contract, or service-level agreement (SLA).',
   },
   {
      type: 'list',
      content:
         'Use of the Website By using our website, you agree to use it solely for lawful and legitimate purposes. You must not use our website:',
      items: [
         'For any purpose that is unlawful or prohibited under applicable laws.',
         'To solicit business in a misleading or fraudulent manner.',
         'To attempt unauthorized access to our backend systems, databases, or data.',
         'To upload or transmit any malware, viruses, worms, or harmful content.',
         'To scrape, download, or harvest data without explicit written permission.',
      ],
   },
   {
      type: 'text',
      content:
         'Misuse of the website or its content may result in termination of access, reporting to authorities, and legal action.',
   },
   {
      type: 'text',
      content:
         'Intellectual Property All content, media, and assets on our website including text, graphics, icons, source code, designs, logos, product names, case studies, and digital materials are the intellectual property of Benzatine Infotech, unless otherwise stated. Unauthorized use, reproduction, redistribution, or replication of any part of this website for commercial or derivative works is strictly prohibited.',
   },
   {
      type: 'text',
      content:
         'You may not use Benzatine’s branding or materials in any public-facing or commercial communication without our express written consent. Any third-party trademarks or service marks appearing on the Site are the property of their respective owners.',
   },
   {
      type: 'text',
      content:
         'Confidentiality and User Submissions If you voluntarily submit personal or business-related information through our contact forms, inquiry emails, or quotation requests, that information is considered confidential. However, we encourage users to request and sign a Non-Disclosure Agreement (NDA) before sharing sensitive business data or intellectual property for project discussions.',
   },
   {
      type: 'text',
      content:
         'Unless an NDA is in place, Benzatine does not guarantee confidentiality of unsolicited submissions and assumes no liability for misuse, replication, or exposure. However, we assure you that all user data will be treated with professional discretion.',
   },
   {
      type: 'text',
      content:
         'Project Engagement and Responsibility All project engagements begin only after mutual confirmation via a formal email or signed agreement. The scope, timeline, deliverables, and payment milestones are defined in the initial agreement. We do not begin work without an understanding of technical and commercial terms.',
   },
   {
      type: 'text',
      content:
         'Benzatine reserves the right to refuse any project or terminate an ongoing project if the client breaches contractual obligations, delays critical inputs, fails to make timely payments, or engages in unethical behavior.',
   },
   {
      type: 'text',
      content:
         'Limitation of Liability To the maximum extent permitted by applicable law, Benzatine Infotech shall not be liable for any indirect, incidental, consequential, punitive, or exemplary damages arising out of or relating to your use of this website or services, even if we have been advised of the possibility of such damages.',
   },
   {
      type: 'text',
      content:
         'We do not guarantee uninterrupted access to the Site or that it will be free from technical issues, bugs, or security breaches. Any reliance you place on information from this Site is strictly at your own risk.',
   },
   {
      type: 'text',
      content:
         'Links to External Websites Our Site may contain links to third-party websites or applications. These links are provided for informational purposes only and do not imply endorsement or responsibility. We are not responsible for the content, policies, or reliability of any external site or service.',
   },
   {
      type: 'text',
      content:
         'Data Protection and Privacy We are committed to protecting the privacy of all users and visitors. Our Privacy Policy outlines how we collect, use, store, and protect personal information. By using our Site, you consent to the collection and use of data in accordance with our Privacy Policy.',
   },
   {
      type: 'text',
      content:
         'Termination of Access Benzatine reserves the right to restrict or terminate your access to the Site at any time, without prior notice, for reasons including breach of these Terms, suspicious activity, misuse of content, or violation of law.',
   },
   {
      type: 'text',
      content:
         'Indemnification You agree to indemnify and hold harmless Benzatine Infotech, its team members, contractors, and partners from any and all claims, damages, liabilities, expenses, or losses arising out of your use of the Site, violation of these Terms, or infringement of third-party rights.',
   },
   {
      type: 'text',
      content:
         'Governing Law and Jurisdiction These Terms shall be governed and interpreted in accordance with the laws of the Republic of India. Any dispute arising from or related to these Terms shall be subject to the exclusive jurisdiction of the courts of Ahmedabad, Gujarat.',
   },
   {
      type: 'contact',
      content:
         'Contact Information If you have any questions about these Terms or need to report a concern, you can reach us at:',
      email: 'contact@benzatine.com',
      emailHref: 'mailto:contact@benzatine.com',
      officeAddress:
         '401 to 403, Laxmi Enclave - 1, opp. Gajera School, Katargam, Surat, Gujarat 395004',
      officeAddressHref: 'https://maps.app.goo.gl/vhY8JxZBUtXohuv58',
   },
   {
      type: 'text',
      content:
         'Entire Agreement These Terms constitute the full and entire understanding between you and Benzatine regarding the use of our Site. They supersede all previous oral or written agreements relating to such use.',
   },
]

function TermsConditionSection() {
   return (
      <section className="section_secondary_bg pt-0" id="terms-condition">
         <div className="container container-xxl">
            <h2 className="text-center tech_title section_heading_title mb-2">
               Our Terms and Conditions
            </h2>
            <h3 className="section_desc">Effective Date: 01-04-2025</h3>
            <div className="container">
               <div className="privacy-parent">
                  {contentData.map((block, index) => {
                     if (block.type === 'text') {
                        return (
                           <div className="intro_description" key={index}>
                              {block.content}
                           </div>
                        )
                     }

                     if (block.type === 'list') {
                        return (
                           <div className="intro_description" key={index}>
                              {block.content}
                              <ul className="faq-list cs-text-primary">
                                 {block.items.map((item, idx) => (
                                    <li key={idx}>{item}</li>
                                 ))}
                              </ul>
                           </div>
                        )
                     }

                     if (block.type === 'contact') {
                        return (
                           <div className="intro_description" key={index}>
                              {block.content}
                              <br />
                              Email:
                              <a
                                 className="cs-text-primary text-decoration-underline"
                                 href={block.emailHref}
                              >
                                 {block.email}
                              </a>
                              <br />
                              Office Address:
                              <a
                                 className="cs-text-primary"
                                 href={block.officeAddressHref}
                                 target="_blank"
                                 rel="noopener noreferrer"
                              >
                                 {block.officeAddress}
                              </a>
                           </div>
                        )
                     }

                     return null
                  })}
               </div>
            </div>
         </div>
      </section>
   )
}

export default TermsConditionSection
